import { render, staticRenderFns } from "./OrdersLineChart.vue?vue&type=template&id=6fbd2b87&scoped=true"
import script from "./OrdersLineChart.vue?vue&type=script&lang=js"
export * from "./OrdersLineChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbd2b87",
  null
  
)

export default component.exports